import axios from "axios"

const base = () => `${process.env.REACT_APP_INVENTORY_API_URL}/master-stock-yearly`

// Kirim satu chunk baris hasil parse Excel "Master Stock HO".
// rows: [{code, satuan, awal, akhir, masuk: {1..12}, keluar: {1..12}}]
export const importMasterStockYearlyBatch = async ({
  outletId,
  rows,
  chunkIndex,
  totalChunks,
  batchId,
  dryRun = false,
  includeStockInit = true,
  asOfDate = null,
}) => {
  const response = await axios.post(`${base()}/import-batch`, {
    outlet_id: outletId,
    rows,
    chunk_index: chunkIndex,
    total_chunks: totalChunks,
    batch_id: batchId,
    dry_run: dryRun,
    include_stock_init: includeStockInit,
    ...(asOfDate ? { as_of_date: asOfDate } : {}),
  })
  return response.data
}

// Resolve daftar KODE -> product_unit_id (name-first, fallback legacy). Dipakai
// sebelum chunking supaya baris yang menunjuk produk sama bisa digabung dulu.
export const resolveMasterStockYearlyCodes = async ({ codes }) => {
  const response = await axios.post(`${base()}/resolve`, { codes })
  return response.data
}

// Update total header order + rebuild sales_daily_agg. Panggil setelah semua chunk.
export const finalizeMasterStockYearly = async ({ outletId }) => {
  const response = await axios.post(`${base()}/finalize`, { outlet_id: outletId })
  return response.data
}

// Cek artefak import existing (guard re-import).
export const getMasterStockYearlyStatus = async ({ outletId }) => {
  const response = await axios.get(`${base()}/status`, {
    params: { outlet_id: outletId },
  })
  return response.data
}

// Hapus seluruh artefak import untuk outlet (orders OMS-*, ledger IMPMV-*, stock init).
export const resetMasterStockYearly = async ({ outletId }) => {
  const response = await axios.delete(base(), {
    data: { outlet_id: outletId },
  })
  return response.data
}
